import * as React from 'react';

import { Debounce } from './Debounce';

interface ChildrenProps {
	value: string;
	onBlur(): void;
	onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

interface Props {
	children: React.PropsWithoutRef<React.DetailedReactHTMLElement<ChildrenProps, HTMLElement>>;
	delayMilliseconds?: number;
	value: string;
	onBlur(): void;
	onChange(value: string): void;
}

export default function DebounceInput({ value, children, delayMilliseconds, onBlur: originalOnBlur, onChange }: Props) {
	return (
		<Debounce delayMilliseconds={delayMilliseconds} value={value} onChange={onChange}>
			{({ value, onBlur, onChange }) =>
				React.cloneElement(children, {
					onBlur: () => {
						onBlur();
						originalOnBlur();
					},
					onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
						onChange(event.currentTarget.value);
					},
					value,
				})
			}
		</Debounce>
	);
}
